import { useState, useEffect } from 'react';
import axios from 'axios';
import { getServiceBySlug } from '@/data/services';
import { getIndustryBySlug } from '@/data/industries';

// Module-level cache so we only fetch once per session
let serviceOverridesCache = null;
let industryOverridesCache = null;

export function useMergedService(slug) {
  const staticService = getServiceBySlug(slug);
  const [override, setOverride] = useState({});

  useEffect(() => {
    if (!slug) return;
    const apply = (data) => setOverride(data[slug] || {});
    if (serviceOverridesCache !== null) { apply(serviceOverridesCache); return; }
    axios.get(`/api/service-overrides`)
      .then(r => { serviceOverridesCache = r.data; apply(r.data); })
      .catch(() => {});
  }, [slug]);

  if (!staticService) return null;
  return {
    ...staticService,
    ...(override.title ? { title: override.title } : {}),
    ...(override.tagline ? { tagline: override.tagline } : {}),
    ...(override.description ? { description: override.description } : {}),
    ...(override.seo_title ? { seoTitle: override.seo_title } : {}),
    ...(override.seo_description ? { seoDesc: override.seo_description } : {}),
    ...(override.faqs ? { faqs: override.faqs } : {}),
  };
}

export function useMergedIndustry(slug) {
  const staticIndustry = getIndustryBySlug(slug);
  const [override, setOverride] = useState({});

  useEffect(() => {
    if (!slug) return;
    const apply = (data) => setOverride(data[slug] || {});
    if (industryOverridesCache !== null) { apply(industryOverridesCache); return; }
    axios.get(`/api/industry-overrides`)
      .then(r => { industryOverridesCache = r.data; apply(r.data); })
      .catch(() => {});
  }, [slug]);

  if (!staticIndustry) return null;
  return {
    ...staticIndustry,
    ...(override.title ? { title: override.title } : {}),
    ...(override.tagline ? { tagline: override.tagline } : {}),
    ...(override.description ? { description: override.description } : {}),
    ...(override.seo_title ? { seoTitle: override.seo_title } : {}),
    ...(override.seo_description ? { seoDesc: override.seo_description } : {}),
  };
}
